import { render, staticRenderFns } from "./DeviceRevision.vue?vue&type=template&id=43239385&scoped=true"
import script from "./DeviceRevision.vue?vue&type=script&lang=js"
export * from "./DeviceRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43239385",
  null
  
)

export default component.exports